import { Extensions } from "@tiptap/core";
import { Document } from "@tiptap/extension-document";
import { HardBreak } from "@tiptap/extension-hard-break";
import { Heading } from "@tiptap/extension-heading";
import { BulletList, ListItem, ListKeymap, OrderedList } from "@tiptap/extension-list";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text } from "@tiptap/extension-text";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Link } from "@tiptap/extension-link";
import { Strike } from "@tiptap/extension-strike";
import { Underline } from "@tiptap/extension-underline";
import { Gapcursor, Placeholder, UndoRedo } from "@tiptap/extensions";
import { toggleEmailBuilderHeadingWeight } from "./emailBuilderHeadingBold";

export type TEmailBuilderHeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

function placeholder(text: string) {
  return Placeholder.configure({ placeholder: text });
}

function linkMark() {
  return Link.configure({
    openOnClick: false,
    autolink: false,
    linkOnPaste: false,
  });
}

function underlineSkippingLinks() {
  return Underline.extend({
    addKeyboardShortcuts() {
      return {
        "Mod-u": () => {
          if (this.editor.isActive("link")) {
            return true;
          }

          return this.editor.commands.toggleUnderline();
        },
      };
    },
  });
}

export function emailBuilderHeadingRichTextExtensions(
  level: TEmailBuilderHeadingLevel,
  placeholderText: string,
): Extensions {
  return [
    Document.extend({ content: "heading" }),
    HardBreak.extend({
      addKeyboardShortcuts() {
        return {
          ...this.parent?.(),
          Enter: () => this.editor.commands.setHardBreak(),
        };
      },
    }),
    Heading.extend({
      addKeyboardShortcuts() {
        return {
          ...this.parent?.(),
          "Mod-b": () => toggleEmailBuilderHeadingWeight(this.editor),
        };
      },
    }).configure({ levels: [level] }),
    Text,
    Italic,
    Strike,
    underlineSkippingLinks(),
    linkMark(),
    UndoRedo,
    placeholder(placeholderText),
  ];
}

export function emailBuilderParagraphRichTextExtensions(placeholderText: string): Extensions {
  return [
    Document.extend({ content: "(paragraph | bulletList | orderedList)+" }),
    Paragraph,
    Text,
    HardBreak,
    BulletList,
    OrderedList,
    ListItem.extend({ content: "paragraph" }),
    ListKeymap,
    Bold,
    Italic,
    Strike,
    underlineSkippingLinks(),
    linkMark(),
    Gapcursor,
    UndoRedo,
    placeholder(placeholderText),
  ];
}

export function emailBuilderLabelRichTextExtensions(placeholderText: string): Extensions {
  return [
    Document.extend({ content: "paragraph" }),
    Paragraph,
    Text,
    Bold,
    Italic,
    Strike,
    Underline,
    UndoRedo,
    placeholder(placeholderText),
  ];
}
